import { createContext, useCallback, useContext, useEffect, useState } from 'react';

const noop = () => {
  console.warn('Calling TokenStore method outside TokenStoreProvider scope.');
};

const TokenStoreContext = createContext({
  currentToken: null,
  storeToken: noop,
  clearToken: noop,
  setUserType: noop,
  isReady: false,
});

const accessTokenSuffix = 'access_token';

export const useTokenStore = () => {
  return useContext(TokenStoreContext);
};

export const TokenStore = ({ children }) => {
  const [currentToken, setCurrentToken] = useState(null);
  const [userType, setUserType] = useState(null);
  const [isReady, setIsReady] = useState(false);

  const getTokenKey = useCallback(type => `${type}_${accessTokenSuffix}`, []);

  useEffect(() => {
    if (!userType) return;

    const token = sessionStorage.getItem(getTokenKey(userType));
    setCurrentToken(token);
    setIsReady(true);
  }, [userType, getTokenKey]);

  const storeToken = useCallback(
    (token, ownerType) => {
      const generatedKey = getTokenKey(ownerType);
      if (!token) {
        sessionStorage.removeItem(generatedKey);
        return;
      }
      sessionStorage.setItem(generatedKey, token);
      setCurrentToken(token);
    },
    [getTokenKey]
  );

  const clearToken = useCallback(() => {
    sessionStorage.removeItem(getTokenKey(userType));
  }, [userType, getTokenKey]);

  return (
    <TokenStoreContext.Provider value={{ currentToken, storeToken, clearToken, setUserType, isReady }}>
      {children}
    </TokenStoreContext.Provider>
  );
};

export const UserTypeTokenContext = ({ userType, children }) => {
  const tokenStore = useTokenStore();

  useEffect(() => {
    tokenStore.setUserType(userType);
  }, [tokenStore, userType]);

  return tokenStore.isReady && children;
};
